import script from "./pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./pagination.vue?vue&type=script&setup=true&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=24bc2902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24bc2902"]])

export default __exports__